import { paths } from '../routes/paths';
import pt from '../locales/pt';

/** Mapa related_module (API) → rota e label na app. */
const REPORT_MODULE_MAP = {
  patrimonio: { path: paths.patrimonio, label: pt.snapshots.report.modules.patrimonio },
  orcamento: { path: paths.budget, label: pt.snapshots.report.modules.orcamento },
  objetivos: { path: paths.goals, label: pt.snapshots.report.modules.objetivos },
  'fundo-emergencia': {
    path: paths.emergencyFund,
    label: pt.snapshots.report.modules.emergencyFund,
  },
  despesas: { path: paths.expenses, label: pt.snapshots.report.modules.despesas },
  rendimentos: { path: paths.income, label: pt.snapshots.report.modules.rendimentos },
  cofres: { path: paths.pots, label: pt.snapshots.report.modules.cofres },
  dividas: { path: paths.dividas, label: pt.snapshots.report.modules.dividas },
};

const LEGACY_PATH_MAP = {
  '/app/patrimonio': 'patrimonio',
  '/app/budget': 'orcamento',
  '/app/goals': 'objetivos',
  '/app/emergency-fund': 'fundo-emergencia',
  '/app/expenses': 'despesas',
  '/app/income': 'rendimentos',
  '/app/pots': 'cofres',
  '/app/dividas': 'dividas',
};

/**
 * Resolve destino acionável de um passo do relatório.
 * @returns {{ path: string, label: string } | null}
 */
export function resolveReportStepLink(step) {
  if (!step) return null;

  if (step.related_module && REPORT_MODULE_MAP[step.related_module]) {
    return REPORT_MODULE_MAP[step.related_module];
  }

  if (step.related_path) {
    const module = LEGACY_PATH_MAP[step.related_path];
    if (module && REPORT_MODULE_MAP[module]) {
      return REPORT_MODULE_MAP[module];
    }
    return {
      path: step.related_path,
      label: step.action_label || pt.snapshots.report.nextSteps.go,
    };
  }

  return null;
}
